
<div class="chart-doughnut">
  <h2>{{ title }}</h2>
  <div class="container">
    <div>
      <div>
        <canvas #doughnutCanvas></canvas>
        <h5>Solicitadas: {{totalLicencias}}</h5>
      </div>
    </div>
  </div>
</div>

